import React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';

import { Typography } from '@ha/dsl';

const styles = () =>
  createStyles({
    root: {
      marginBottom: '1rem',
    },
  });

const MarkdownH3Internal: React.FC<WithStyles<typeof styles>> = ({
  children,
  classes,
}) => (
  <Typography.H3 component="h3" className={classes.root}>
    {children}
  </Typography.H3>
);

const MarkdownH3 = withStyles(styles)(MarkdownH3Internal);
export { MarkdownH3 };
